<template>
  <div class="sec-list-item">
    <div>
      <i class="uil-list-ul uk-sortable-handle"></i>
      <a style="cursor: pointer"
         @click="$emit('edit', educationIndex)">
        {{ education.name }}
      </a>
      <label class="mb-0 mx-2" style="font-size: 0.75rem;
          background: #3e416d;
          padding: 1px 5px;
          border-radius: 3px;
          color: white;
        ">
        {{ contentTypeName }}
      </label>
    </div>
    <div>
      <div class="btn-act">
        <a :uk-tooltip="`title: ${$t('general.edit')}`"
           style="cursor: pointer"
           @click="$emit('edit', educationIndex)">
          <i class="icon-feather-edit"></i>
        </a>
        <a :uk-tooltip="`title: ${$t('general.remove')}`"
           style="cursor: pointer"
           @click="$emit('delete', educationIndex)">
          <i class="icon-feather-trash"></i>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "EducationItemCard",
  props: {
    education: {
      type: Object,
      required: true
    },
    educationIndex: {
      type: Number,
      required: true
    },
    contentTypeName: {
      type: String,
      default: ""
    }
  },
  emits: ['edit', 'delete']
};
</script>

<style scoped>
/* Component uses global .sec-list-item styles from style.scss */
/* No additional styles needed - matches existing design */
</style>
